import { Avatar, Button, Grid, Paper, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import axios from 'axios';
import React, { useState } from 'react';
import logoWhite from '../assets/logo-icon-white.png'
import { MobileNumberValidation } from '../utils/MobileNumberCheck';
import { setAuth, setAuthenticationToken } from '../utils/TokenHandler';
import MaterialNotifyComponent from './MaterialNotifyComponent';

function Login(props) {

    const paperStyle = {
        padding: 20,
        height: 380,
        width: 250,
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: 'auto',
        maxWidth: '100%',
        maxHeight: '100%',
        overflow: 'auto'
    };

    const avatarStyle = {
        background: '#2e3192',
        width: '100px',
        height: '100px'
    };

    const imgStyle = {
        width: "70px",
        height: '70px'
    };

    const formElementStyle = {
        margin: "10px 0"
    };

    const useStyles = makeStyles(theme => ({
        root: {
            "& .MuiFormLabel-root": {
                right: 0 , // or black
                left: 'unset'
            }
        }
    }));

    const classes = useStyles();

    //State----------------------------------------------------------------------------------
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    //---------------------------------------------------------------------------------------

    const loginHandler = (e) => {
        let mobileObject = MobileNumberValidation(userName);
        if (mobileObject.isValid) {
            axios.post('api/v2/Authorization/WebLogin', {
                userName: mobileObject.validNumber,
                password: password
            }).then(response => {
                if (response.data && response.data.access_token !== "Wrong Code") {
                    setAuthenticationToken(response.data);
                    setAuth(response.data.access_token);
                    props.history.push('/');
                }
                else if (response.data.access_token === "Wrong Code") {
                    setMessageNotify({
                        severity: "warning",
                        message: "نام کاربری و کلمه عبور وارد شده صحیح نمی باشد",
                        open: true
                    });
                }
                else {
                    setMessageNotify({
                        severity: "error",
                        message: "خطا در ورود به باشگاه",
                        open: true
                    });
                }
            }).catch(e => {
                setMessageNotify({
                    severity: "error",
                    message: "خطا در ورود به باشگاه",
                    open: true
                });
            });
        }
        else {
            setMessageNotify({
                severity: "warning",
                message: "نام کاربری (شماره تلفن همراه) به صورت صحیح وارد نشده است",
                open: true
            });
        }

    }

    return (
        <>
            <Grid>
                <Paper elevation={10} style={paperStyle}>
                    <Grid align='center'>
                        <Avatar style={avatarStyle}><img style={imgStyle} src={logoWhite} alt="NEC" /></Avatar>
                        <h2>باشگاه مشتریان NEC</h2>
                    </Grid>
                    <TextField style={formElementStyle} className={classes.root} onChange={(e) => { setUserName(e.target.value) }} value={userName} placeholder="نام کاربری را وارد کنید" label="نام کاربری" variant="standard" required fullWidth />
                    <TextField style={formElementStyle} className={classes.root} onChange={(e) => { setPassword(e.target.value) }} value={password} placeholder="کلمه عبور را وارد کنید" label="کلمه عبور" variant="standard" type="password" required fullWidth />
                    <Button onClick={loginHandler} style={formElementStyle} type="submit" variant="contained" fullWidth>ورود</Button>
                    <Button onClick={e => { props.history.push('/loginByMobile') }} variant="text" fullWidth>ورود با شماره موبایل</Button>
                </Paper>
            </Grid>
            <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />            
            <div style={{height:'90vh'}}></div>
        </>
    );
}

export default Login;